import { createContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { defaultOrder } from "@/lib/menuItems";

export const MenuConfigContext = createContext({ items: {}, order: {} });
export const MENU_CHANGED = "menu-config-changed";

// Loads the menu changes for the signed-in role; reloads when a super admin saves.
export function useMenuConfig(user) {
  const [items, setItems] = useState({});
  useEffect(() => {
    if (!user?.id) return undefined;
    const load = () => api.get("/menu-config").then((r) => setItems(r.data.items || {})).catch(() => {});
    load();
    window.addEventListener(MENU_CHANGED, load);
    return () => window.removeEventListener(MENU_CHANGED, load);
  }, [user?.id, user?.role]);
  return { items, order: defaultOrder(user?.role) };
}
